import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Form,
  Breadcrumb,
  Tabs,
  Avatar,
  Typography,
  Tag,
  Drawer,
  Table,
  Modal,
} from "antd";
import {
  DoubleRightOutlined,
  MailOutlined,
  PhoneOutlined,
  EditOutlined,
  PlusCircleOutlined,
  LockOutlined,
  StarFilled,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faBriefcase,
  faBuildingShield,
  faFileContract,
  faFileInvoice,
  faFolderOpen,
  faArrowLeft,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  GetClientByIdApi,
  getProjectsListBySubClientId,
  UpsertProjectApi,
} from "../ClientsApi";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useNavigate, useParams } from "react-router-dom";
import ClientInfo from "./ClientInfo";
import logoicon from "../../../logoicon.png";
//import ClientProjects from "./ClientProjects";
import Estimates from "../Quotes/Estimates";
import WorkOrders from "../WorkOrders/WorkOrders";
import ProductsInfo from "../Components/ProductsInfo";
import AddClient from "./AddClient";
import Invoices from "features/Invoices/Invoices";
import InvoicesList from "features/Invoices/Components/InvoicesList";

function ClientDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Column } = Table;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const intl = useIntl();
  const { Title, Text } = Typography;
  const [activeTab, setActiveTab] = useState("1");
  const [openDrawer, setOpenDrawer] = useState(false);
  const { clientId, partnerId, projectId } = useParams();
  const subClientId = clientId;
  const client = useSelector((state) => state.clients.clientListById);
  const companyList = useSelector((state) => state.lookup.companyNames);
  const projectsList = useSelector(
    (state) => state.clients.projectsListBySubClientId
  );
  const companyId = localStorage.getItem("CompanyId");
  const [partnerAvailable, setPartnerAvailable] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const handleTabChange = (key) => {
    if (String(key) === "4") {
      dispatch(GetClientByIdApi(clientId));
    }
    setActiveTab(key);
  };
  const handleEdit = (clientId) => {
    // navigate(`/editclient/${id}`);
    setOpenDrawer(true);
  };
  // const handleAddClient = () => {
  //   navigate("/addclient");
  // };
  const companyName = React.useMemo(
    () =>
      client?.clientCompanyMapping?.[0]?.companyId && companyList?.length > 0
        ? companyList.find(
            (company) => company.id === client.clientCompanyMapping[0].companyId
          )?.companyName
        : client?.companyName || client?.name || "N/A",
    [client, companyList]
  );
  useEffect(() => {
    if (clientId) {
      dispatch(GetClientByIdApi(clientId));
    }
  }, [clientId, dispatch]);
  useEffect(() => {
    if (partnerId) {
      setPartnerAvailable(true);
    }
  }, [partnerId]);
  const showModal = (project = null) => {
    setEditingProject(project);
    if (project) {
      form.setFieldsValue({
        name: project.projectName,
        description: project.description,
      });
    } else {
      form.resetFields();
    }
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const addOrUpdateProject = () => {
    form
      .validateFields()
      .then((values) => {
        const input = {
          id: editingProject?.id || 0,
          partnerId: partnerId ? parseInt(partnerId) : null,
          subClientId: subClientId ? parseInt(subClientId) : null,
          projectName: values.name,
          description: values.description,
        };

        const filter = {
          pageNo: null,
          pageSize: null,
          searchQuery: "",
        };

        dispatch(UpsertProjectApi(input, filter, subClientId)).then(
          (success) => {
            if (success) {
              setIsModalOpen(false);
              setEditingProject(null);
              form.resetFields();
            }
          }
        );
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  useEffect(() => {
    if (projectId) {
      const project = projectsList.find((p) => p.id === parseInt(projectId));
      setSelectedProject(project || { id: parseInt(projectId) });
    } else {
      setSelectedProject(null);
    }
  }, [projectId, projectsList]);
  useEffect(() => {
    if (subClientId) {
      const searchParams = {
        pageNo: currentPage,
        pageSize: pageSize,
        searchQuery: searchTerm,
      };
      dispatch(getProjectsListBySubClientId(searchParams, subClientId));
    }
  }, [subClientId, dispatch, searchTerm, , currentPage, pageSize]);
  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part detailsposition">
            <Row align="middle" justify="space-between" gutter={[16, 16]}>
              <Col xs={24} sm={16} lg={12}>
                <h4>
                  <FormattedMessage id="ClientDetails.ClientDetails" />
                </h4>
                <p>
                  Manage client quotes, work orders, invoices, and products.
                </p>
              </Col>

              <Col
                xs={24}
                sm={8}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  textAlign: "right",
                }}
                className="text-right detailsbtns"
              >
                <Space>
                  <Breadcrumb
                    separator={<DoubleRightOutlined />}
                    items={[
                      partnerAvailable && {
                        title: <FormattedMessage id="PartnerCLient.Partners" />,
                        href: `/${companyId}/partner`,
                      },
                      {
                        title: (
                          <FormattedMessage
                            id={
                              partnerAvailable
                                ? "PartnerClient.PartnerClientDetails"
                                : "ClientDetails.Clients"
                            }
                          />
                        ),
                        href: partnerAvailable
                          ? `/${companyId}/${partnerId}/partner_client_details`
                          : `/${companyId}/clients`,
                      },
                      {
                        title: (
                          <FormattedMessage id="ClientDetails.ClientDetails" />
                        ),
                      },
                    ]}
                  />
                </Space>
              </Col>
            </Row>
          </div>

          <Card className="clientview-new">
            <Row
              align="middle"
              justify="space-between"
              gutter={[16, 16]} // adds spacing between cols on mobile
            >
              {/* 🧍 Client Info */}
              <Col xs={24} sm={14}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 12,
                    flexWrap: "wrap", // ✅ allows wrapping on small screens
                  }}
                >
                  {/* Avatar */}
                  <div style={{ width: 48, flexShrink: 0 }}>
                    <Avatar
                      style={{
                        backgroundColor: "#3a5892",
                        verticalAlign: "middle",
                        width: 48,
                        height: 48,
                        fontSize: 18,
                      }}
                    >
                      {(client?.isResidential
                        ? client?.name
                        : client?.companyName
                      )
                        ?.charAt(0)
                        .toUpperCase()}
                    </Avatar>
                  </div>

                  {/* Client Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <h4
                      className="word-break"
                      style={{
                        fontWeight: "bold",
                        marginBottom: 4,
                        wordBreak: "break-word",
                      }}
                    >
                      {client?.isResidential
                        ? client?.name
                        : client?.companyName}
                    </h4>

                    {/* ✅ Mobile-friendly contact details */}
                    <Space
                      size={[8, 4]}
                      wrap
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        color: "#555",
                        fontSize: 13,
                      }}
                    >
                      <p style={{ margin: 0 }}>
                        <PhoneOutlined style={{ marginRight: 6 }} />
                        {client?.countryCode}&nbsp;
                        {client?.phone?.length === 10
                          ? client?.phone?.replace(
                              /(\d{3})(\d{3})(\d{4})/,
                              "$1-$2-$3"
                            )
                          : client?.phone}
                      </p>
                      <p style={{ margin: 0 }} className="sm-d-none">
                        |
                      </p>
                      <p style={{ margin: 0, wordBreak: "break-all" }}>
                        <MailOutlined style={{ marginRight: 6 }} />
                        {client?.email}
                      </p>
                    </Space>
                  </div>
                </div>
              </Col>

              {/* 🏢 Partner Info */}
              {client?.partnerClientId && (
                <Col xs={24} sm={6} style={{ textAlign: "center" }}>
                  <p>
                    <FormattedMessage id="ClientDetails.PartnerOf" />
                  </p>
                  <h4
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                    title={client?.partnerCompanyName}
                  >
                    {client?.partnerCompanyName}
                  </h4>
                </Col>
              )}

              {/* ✏️ Edit Button */}
              <Col xs={24} sm={4} className="sm-text-center text-right">
                <Button
                  type="primary"
                  variant="solid"
                  onClick={() => handleEdit(client?.id)}
                  style={{ width: "100%", maxWidth: 180 }} // ✅ auto full width on mobile
                >
                  <EditOutlined />
                  <FormattedMessage id="ClientDetails.EditClient" />
                </Button>
              </Col>
            </Row>
          </Card>

          <Row gutter={[16, 16]} className="mt-10">
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
              <ClientInfo />
            </Col>
            <Col xs={24} sm={12} md={18} lg={18} xl={18}>
              {partnerAvailable ? (
                !selectedProject ? (
                  // Show Projects Table for PartnerClient
                  <Card
                    title={<FormattedMessage id="Project.List" />}
                    size="small"
                  >
                    <Row
                      align="middle"
                      justify="space-between"
                      gutter={[16, 8]}
                    >
                      <Col xs={24} sm={14} lg={8}>
                        <Input.Search
                          placeholder={intl.formatMessage({
                            id: "Project.Search",
                          })}
                          onSearch={(value) => setSearchTerm(value)}
                          onChange={(e) => {
                            if (!e.target.value) setSearchTerm("");
                          }}
                          allowClear
                        />
                      </Col>
                      <Col xs={24} sm={10} lg={8} className="text-right">
                        <Button type="primary" onClick={showModal}>
                          <PlusCircleOutlined />{" "}
                          {<FormattedMessage id="Project.AddProject" />}
                        </Button>
                      </Col>
                    </Row>
                    <Table
                      dataSource={projectsList}
                      rowKey="id"
                      className="mt-10"
                      scroll={{ x: 500 }}
                      bordered
                      pagination={{
                        current: projectsList?.pageNumber || currentPage,
                        pageSize: projectsList?.pageSize || pageSize,
                        total: projectsList?.totalItems || 0,
                        onChange: (page, size) => {
                          setCurrentPage(page);
                          setPageSize(size);
                        },
                      }}
                    >
                      <Column
                        title={<FormattedMessage id="Project.Id" />}
                        dataIndex="id"
                        key="id"
                        width={80}
                      />
                      <Column
                        title={<FormattedMessage id="Project.Name" />}
                        dataIndex="projectName"
                        key="projectName"
                        render={(text, record) => (
                          <Button
                            type="link"
                            style={{ padding: 0 }}
                            onClick={() =>
                              navigate(
                                `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/projects/${record.id}`
                              )
                            }
                          >
                            {text}
                          </Button>
                        )}
                      />
                      <Column
                        title={<FormattedMessage id="Project.Description" />}
                        dataIndex="description"
                        key="description"
                        // render={(desc) =>
                        //   desc?.length > 50 ? `${desc.slice(0, 50)}...` : desc
                        // }
                      />
                      <Column
                        title={<FormattedMessage id="Common.Action" />}
                        key="actions"
                        width={100}
                        render={(_, record) => (
                          <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={() => showModal(record)}
                          />
                        )}
                      />
                    </Table>
                  </Card>
                ) : (
                  // Show Tabs when project is selected
                  <Card
                    title={selectedProject.projectName}
                    size="small"
                    extra={
                      <Button
                        type="link"
                        style={{ padding: 0 }}
                        icon={<FontAwesomeIcon icon={faArrowLeft} />}
                        onClick={() =>
                          navigate(
                            `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
                          )
                        }
                      >
                        <FormattedMessage id="Project.BackToProject" />
                      </Button>
                    }
                  >
                    <Tabs
                      activeKey={activeTab}
                      onChange={handleTabChange}
                      centered
                    >
                      <Tabs.TabPane
                        tab={
                          <>
                            <FontAwesomeIcon icon={faFileInvoice} />{" "}
                            <FormattedMessage id="Dashboard.Quotes" />
                          </>
                        }
                        key="1"
                      >
                        <Estimates projectId={selectedProject.id} />
                      </Tabs.TabPane>
                      <Tabs.TabPane
                        tab={
                          <>
                            <FontAwesomeIcon icon={faFileContract} />{" "}
                            <FormattedMessage id="ClientDetails.WorkOrders" />
                          </>
                        }
                        key="2"
                      >
                        <WorkOrders projectId={selectedProject.id} />
                      </Tabs.TabPane>
                      <Tabs.TabPane
                        tab={
                          <>
                            <FontAwesomeIcon icon={faScrewdriverWrench} />{" "}
                            Products
                          </>
                        }
                        key="3"
                      >
                        <ProductsInfo projectId={selectedProject.id} />
                      </Tabs.TabPane>
                      <Tabs.TabPane
                        tab={
                          <>
                            <FontAwesomeIcon icon={faFileInvoice} />{" "}
                            <FormattedMessage id="Invoice.Heading" />
                          </>
                        }
                        key="4"
                      >
                        <InvoicesList
                          clientId={clientId}
                          projectId={selectedProject.id}
                        />
                      </Tabs.TabPane>
                    </Tabs>
                  </Card>
                )
              ) : (
                // 🚀 Show direct Tabs for Normal Client (skip projects list)
                <Card
                  // title={<FormattedMessage id="ClientDetails.ClientTabs" />}
                  size="small"
                >
                  <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    centered
                  >
                    <Tabs.TabPane
                      tab={
                        <>
                          <FontAwesomeIcon icon={faFileInvoice} />{" "}
                          <FormattedMessage id="Dashboard.Quotes" />
                        </>
                      }
                      key="1"
                    >
                      <Estimates clientId={clientId} />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <>
                          <FontAwesomeIcon icon={faFileContract} />{" "}
                          <FormattedMessage id="ClientDetails.WorkOrders" />
                        </>
                      }
                      key="2"
                    >
                      <WorkOrders clientId={clientId} />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <>
                          <FontAwesomeIcon icon={faScrewdriverWrench} />{" "}
                          Products
                        </>
                      }
                      key="3"
                    >
                      <ProductsInfo clientId={clientId} />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <>
                          <FontAwesomeIcon icon={faFileInvoice} />{" "}
                          <FormattedMessage id="Invoice.Heading" />
                        </>
                      }
                      key="4"
                    >
                      <InvoicesList
                        clientId={clientId}
                        CreateInvoiceVisible={false}
                      />
                    </Tabs.TabPane>
                  </Tabs>
                </Card>
              )}
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        title={
          editingProject?.id ? (
            <FormattedMessage id="Project.EditProject" />
          ) : (
            <FormattedMessage id="Project.AddProject" />
          )
        }
        open={isModalOpen}
        onOk={addOrUpdateProject}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingProject(null);
          form.resetFields();
        }}
        okText={<FormattedMessage id="Common.Save" />}
        cancelText={<FormattedMessage id="Common.Cancel" />}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label={<FormattedMessage id="Project.ProjectName" />}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "Project.PleaseEnterProjectName",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label={<FormattedMessage id="Project.Description" />}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "Project.PleaseEnterDescription",
                }),
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
      <Drawer
        title={<FormattedMessage id="AddClient.EditClient" />}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        width={600}
      >
        <AddClient
          onClose={() => setOpenDrawer(false)}
          clientId={clientId}
          partnerClientId={client?.partnerClientId}
          isValidationRequired={true}
        />
      </Drawer>
    </>
  );
}

export default ClientDetails;
